var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3411 7.845L6.16857 15.0175L4.99023 13.8392L12.1619 6.66667H5.84107V5H15.0077V14.1667H13.3411V7.845Z",
    fill: "#2262ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupArrow);
export default __webpack_public_path__ + "static/media/popup_arrow.7722909957685167966b1398c93fd01d.svg";
export { ForwardRef as ReactComponent };